import { Assessment } from '@/models/greathall/assessment.model';
import { AssessmentState } from './state';
import { MutationTree } from 'vuex';

const mutations: MutationTree<AssessmentState> = {
  SET_ASSESSMENTS(state, assessments: Assessment[]) {
    state.assessments = assessments;
  },
  SET_ASSESSMENT_DETAILS(state, assessmentDetails: Assessment) {
    state.assessmentDetails = assessmentDetails;
  },
};

export default mutations;
